import {Theme, useTheme, Card as MUICard} from "@mui/material";
import {SxProps} from "@mui/system";

export type CardProps = {
    /** The variant of the card which defines its color scheme */
    variant: "primary" | "error";

    /** Custom styles to apply to the card */
    sx?: SxProps<Theme>;

    /** The content of the card */
    children: React.ReactNode;
};

const getColors = (theme: Theme, variant: CardProps["variant"]): {cardColor: string; textColor: string} => {
    switch (variant) {
        case "primary":
            return {
                cardColor: theme.palette.primary.main,
                textColor: theme.palette.primary.contrastText,
            };
        case "error":
            return {
                cardColor: theme.palette.error.main,
                textColor: theme.palette.error.contrastText,
            };
        default:
            return {
                cardColor: theme.palette.primary.main,
                textColor: theme.palette.primary.contrastText,
            };
    }
};

/**
 * A simple but customizable styled card component.
 **/
const Card: React.FC<CardProps> = ({variant, sx, children}) => {
    const theme = useTheme();

    const {cardColor, textColor} = getColors(theme, variant);

    return (
        <MUICard
            variant="outlined"
            sx={{
                backgroundColor: cardColor,
                color: textColor,
                padding: theme.spacing(2),
                borderRadius: theme.shape.borderRadius,
                ...sx,
            }}
        >
            {children}
        </MUICard>
    );
};

export default Card;
